import Cookie from 'js-cookie';
import jwt from 'jsonwebtoken';
import { toast } from 'react-toastify';
import axiosInstance from '../components/utils/axios/axiosInstance';
import {
  AUTH_SUCCESS,
  AUTH_LOGOUT,
  SAVE_RECAPTCHA_TOKEN
} from './constantsActions';

export function setTokenHeader(jwtToken) {
  axiosInstance.defaults.headers.common = {
    Authorization: `Bearer ${jwtToken}`
  };
}

export function getExpDate(jwtToken) {
  const { exp } = jwt.decode(jwtToken);
  return new Date(exp * 1000);
}

function setCookies(userData) {
  const expDate = getExpDate(userData.jwtToken);

  Cookie.set('token', userData.jwtToken, { expires: expDate });
  Cookie.set('expirationDate', expDate, { expires: expDate });
  Cookie.set('userData', userData, { expires: expDate });
}

function deleteCookies() {
  Cookie.remove('token');
  Cookie.remove('expirationDate');
  Cookie.remove('userData');
}

export const authLogout = () => {
  deleteCookies();
  return { type: AUTH_LOGOUT };
};

export const authSuccess = (userData) => (dispatch) => {
  const expDate = getExpDate(userData.jwtToken);
  const expTime = expDate - Date.now();
  axiosInstance.defaults.headers.common = {
    Authorization: `Bearer ${userData.jwtToken}`
  };

  setTimeout(() => {
    dispatch(authLogout());
  }, expTime);

  dispatch({
    type: AUTH_SUCCESS,
    payload: userData
  });
};

export const auth = (email, password) => (dispatch) => {
  const regData = {
    userName: email,
    password
  };
  return new Promise((resolve, reject) => {
    axiosInstance
      .post('/api/auth/authenticate', regData)
      .then(({ status, data }) => {
        if (status === 200) {
          setCookies(data);
          setTokenHeader(data.jwtToken);
          dispatch(authSuccess(data));
          resolve();
        } else {
          reject();
        }
      })
      .catch((err) => {
        reject(err.toString());
      });
  });
};

export const authAutoLogin = () => (dispatch) => {
  const userData = Cookie.getJSON('userData');

  if (!userData) {
    dispatch(authLogout());
  } else {
    const expDate = getExpDate(userData.jwtToken);

    if (expDate <= new Date()) {
      dispatch(authLogout());
    } else {
      setTokenHeader(userData.jwtToken);
      dispatch(authSuccess(userData));
    }
  }
};

export const saveRecaptcha = (recaptchaToken) => (dispatch) => {
  if (recaptchaToken) {
    axiosInstance.defaults.headers.common.recapture_token = recaptchaToken;
    dispatch({
      type: SAVE_RECAPTCHA_TOKEN,
      payload: recaptchaToken
    });
  } else {
    toast.error('Selhala verifikace Vaši identity.');
  }
};
